// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import store from './store'
import router from './router'
import Amplify from 'aws-amplify'
import Vuex from 'vuex'
import 'es6-promise/auto'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/styles/index.scss'
import './assets/styles/index.css'
import Notifications from 'vue-notification'
import 'vue-search-select/dist/VueSearchSelect.css'

/* Amplify.Logger.LOG_LEVEL = 'ERROR' */

const {
  AWS_REGION,
  AWS_USERPOOL_ID,
  AWS_USERPOOL_WEBCLIENTID
} = process.env

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: AWS_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: AWS_USERPOOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: AWS_USERPOOL_WEBCLIENTID
  }
})

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(Notifications)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
